module.exports = __webpack_public_path__ + "static/media/tea2.b81447b1.png";